export const NEXT_PUBLIC_ROX_KEY = process.env.NEXT_PUBLIC_ROX_KEY
